<script>
    import { fade } from 'svelte/transition';
    let visible = true;

    import {count} from './store.js';

	let name = 'kim';
	$: fullName = 'john' + name;
	let 과일 = ['딸기', '바나나', '사과'];
</script>

<main>

    {#each 과일 as item}
        <p>{ item }</p>
    {/each}

    {#if 3 > 1}
        <label>
        	<input type="checkbox" bind:checked={visible}>
        	visible
        </label>

        {#if visible}
        	<p transition:fade>
        		Fades in and out
        	</p>
        {/if}
    {/if}

	<h1>Hello {fullName}! {$count}</h1>
		<button on:click={()=>{ $count++ }}>버튼</button>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>